import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9371f89c"
import script from "./index.vue?vue&type=script&route=%2Fset_up_shop%2Fapply&lang=js"
export * from "./index.vue?vue&type=script&route=%2Fset_up_shop%2Fapply&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports